import * as action_type from './../actions/calendar/action_types';
import { addOrReplace } from './../../utils/dataParser'
import { CalendarSaga } from '../redux-saga/calendarSaga';
import {parseAPIData as parseMatchListAPIData} from "../../utils/parseFootballAPIResponse"

const initialState = {
    matchesList: [],
    predictedData: [],
    isModalOpen:true,
}
const CalendarReducer = (state = initialState, action) => {
    switch (action.type) {
        case action_type.GET_MATCH_DETAILS_SUCCESS: {
            const raw = action.data && action.data.response;
            const list = parseMatchListAPIData(raw);
            return Object.assign({}, state, {
                matchesList: Array.isArray(list) ? list : [],
                isFetching: false
            });
        }
        case action_type.ADD_PREDICTION:
            let parsedData = addOrReplace(state.predictedData, { matchid: action.data.matchid }, action.data,action.otherData);
            return Object.assign({}, state, {
                predictedData: parsedData
            });
        case action_type.GET_PREDICTION_SUCCESS:
            return Object.assign({}, state, {
                predictedData: action.data
            });
        case action_type.CLOSE_MODAL:
            return Object.assign({}, state, {
                isModalOpen: false
            });
        case action_type.OPEN_MODAL:
            return Object.assign({}, state, {
                isModalOpen: true
            });
        default:
            return state;
    }
}

export default CalendarReducer;